import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\software\\components\\software-view.tsx");
